import React from 'react';
import { Form } from 'react-bootstrap';
import { TextField } from '@mui/material';
// import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { PasswordVerifySteps } from '../../../../shared/PasswordVerifySteps';
import { useTranslation } from 'react-i18next';
import InputPassword from '../../../../shared/components/input/InputPassword';

interface ChangePasswordTabProps {
    formik: any;
}
export function ChangePasswordTab({ formik }: ChangePasswordTabProps) {
    const { t } = useTranslation();

    return (
        <>
            <Form.Group className="my-3">
                <TextField
                    fullWidth
                    label={t('general.current_password')}
                    variant="outlined"
                    size="small"
                    name="currentPassword"
                    value={formik.values.currentPassword}
                    onChange={formik.handleChange}
                    error={formik.touched.currentPassword && Boolean(formik.errors.currentPassword)}
                    helperText={formik.touched.currentPassword && formik.errors.currentPassword}
                />
            </Form.Group>

            <Form.Group className="my-3">
                <InputPassword
                    label={t('general.new_password')}
                    name="password"
                    className="w-100"
                    autoComplete="current-password"
                    onChange={formik.handleChange}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                    size="small"
                />
            </Form.Group>

            <Form.Group className="my-3">
                <InputPassword
                    label={t('general.repeat_password')}
                    name="repeatPassword"
                    className="w-100"
                    autoComplete="current-password"
                    onChange={formik.handleChange}
                    error={formik.touched.repeatPassword && Boolean(formik.errors.repeatPassword)}
                    helperText={formik.touched.repeatPassword && formik.errors.repeatPassword}
                    size="small"
                />
            </Form.Group>

            <PasswordVerifySteps password={formik.values.password} />
        </>
    );
}
